var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_205_1724)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.0479,
    cy: 25.0479,
    r: 20.5479,
    fill: "white",
    stroke: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2008 21.4947C28.2008 21.6965 28.2681 21.8311 28.4026 21.9656L31.7665 25.3294C32.0356 25.5985 32.4392 25.5985 32.7083 25.3294C32.9774 25.0603 32.9774 24.6567 32.7083 24.3876L29.3445 21.0237C29.0754 20.7546 28.6718 20.7546 28.4026 21.0237C28.2681 21.1583 28.2008 21.2928 28.2008 21.4947Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2008 28.2179C28.2008 28.4197 28.2681 28.5542 28.4026 28.6888C28.6718 28.9579 29.0754 28.9579 29.3445 28.6888L32.7083 25.325C32.9774 25.0559 32.9774 24.6522 32.7083 24.3831C32.4392 24.114 32.0356 24.114 31.7665 24.3831L28.4026 27.7469C28.2681 27.8815 28.2008 28.016 28.2008 28.2179Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8004 24.8585C20.8004 25.2621 21.0695 25.5313 21.4732 25.5313L32.2374 25.5312C32.6411 25.5312 32.9102 25.2621 32.9102 24.8585C32.9102 24.4548 32.6411 24.1857 32.2374 24.1857H21.4732C21.0695 24.1857 20.8004 24.4548 20.8004 24.8585Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_205_1724",
    x: 0,
    y: 0,
    width: 58.0957,
    height: 58.0957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_205_1724"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_205_1724",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToright);
export default __webpack_public_path__ + "static/media/toright.f85864856e456dcc99c58785c8fb41d4.svg";
export { ForwardRef as ReactComponent };